<template>
  <div v-if="edit">
    <h4 class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
      Enter your factoring company.
    </h4>

    <autocomplete-search
      id="factoring_companies_input"
      :data="data"
      placeholder="Enter company name"
      label="Search Factoring Company"
      :items="factors"
      :field="'payment.factoring_company.name'"
      :object-field="'payment.factoring_company'"
      :handle-select="handleFactoringCompany"
      :handle-on-change="handleFactorSearch"
      :toggle-button="toggleButton"
      name="company_name"
    >
      <!-- <div
        @click="openModal"
        class="pl-4 pb-2 pt-2 pr-4 flex justify-between"
      >
        <p class="text-body-color">
          Add New Company
        </p>
        <img src="@/assets/plus-sign.svg" />
      </div> -->
    </autocomplete-search>
    <!-- <div class="h-60">
      <div
        v-show="show_details"
        class="mt-6"
      >
        <p class="text-body-color w-full border-b-2 rounded-1 pb-1 mb-2">Factoring Company Details</p>
        <div>
          <label class="text-2xs font-bold uppercase text-gray-over-dark">Factoring Company Name</label>
          <p>{{factoring_company_details?.name}}</p>
        </div>
        <div>
          <label class="text-2xs font-bold uppercase text-gray-over-dark">Phone #</label>
          <p>{{factoring_company_details?.phone}}</p>
        </div>
        <div>
          <label class="text-2xs font-bold uppercase text-gray-over-dark">Email</label>
          <p>{{factoring_company_details?.email_address}}</p>
        </div>
      </div>
    </div> -->
    <!-- <add-company-modal
      v-if="showModal"
      :visible="showModal"
      @close="onCloseModal"
      :formPosition="formPosition"
      :nextStep="nextStep"
      :skipStep="skipStep"
    >
    </add-company-modal> -->
  </div>
  <div />
</template>

<script>
import { ref } from 'vue';
import AutocompleteSearch from '../../AutocompleteSearch.vue';
// import AddCompanyModal from "../../modals/AddCompanyModal.vue";

export default {
  name: 'FactorForm',
  components: {
    'autocomplete-search': AutocompleteSearch,
    // "add-company-modal": AddCompanyModal,
  },
  props: {
    data: Object,
    formPosition: Number,
    // nextStep: Function,
    stepName: String,
    // skipStep: Function,
    edit: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    const showModal = ref(false);
    const openModal = () => {
      showModal.value = true;
    };

    const onCloseModal = () => {
      showModal.value = false;
    };
    return {
      openModal,
      showModal,
      onCloseModal,
    };
  },
  data() {
    return {
      factors: [],
      factoring_company_details: {},
      show_details: false,
    };
  },
  watch: {
    stepName(val) {
      if (
        val === 'Payment-2' &&
        Object.keys(this.factoring_company_details).length === 0
      ) {
        this.$store.commit('toggleDisabledButton', {
          bool: true,
          source: 'FactorForm #2',
        });
      }
    },
  },
  methods: {
    async getFactorsData(search) {
      let res = await this.$store.dispatch(
        'factors/getFactorsDataBySearch',
        search
      );
      return res;
    },
    toggleDetails() {
      this.show_details = true;
    },
    handleFactoringCompany(item) {
      this.factoring_company_details = item;
      this.factoring_company_details.name.length
        ? this.toggleButton(false)
        : this.toggleButton(true);
      this.show_details = true;
      let body = {
        payment_term_id: this.$store.state.payments.payment_term_id,
        factor_id: item.id,
      };
      this.updateOnboardingPacket(body);
    },
    handleFactorSearch(search) {
      this.getFactorsData(search).then((el) => {
        this.factors = el.data;
      });
    },
    toggleButton(value) {
      this.$store.commit('toggleDisabledButton', {
        bool: value,
        source: 'FactorForm #1',
      });
    },
    updateOnboardingPacket(body) {
      this.$store.dispatch('payments/setPaymentBody', body);
    },
  },
};
</script>
